import React, { useState, useEffect } from 'react';
import { FaPlus, FaEdit, FaTrash, FaSave, FaTimes } from 'react-icons/fa';
import { authFetch, getAuthHeaders } from './authHelper';

const emptyPlan = {
  name: '', price: '', description: '', features: [], popular: 0, display_order: 0, active: 1,
};

const AdminPricing = () => {
  const [plans, setPlans] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(emptyPlan);
  const [featInput, setFeatInput] = useState('');
  const [loading, setLoading] = useState(true);

  const fetchPlans = () => {
    authFetch('/api/admin/pricing.php')
      .then((res) => res.json())
      .then((data) => { setPlans(Array.isArray(data) ? data : []); setLoading(false); })
      .catch(() => setLoading(false));
  };

  useEffect(() => { fetchPlans(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isEdit = editing !== null && editing !== 'new';
    const url = isEdit ? `/api/admin/pricing.php?id=${editing}` : '/api/admin/pricing.php';
    const method = isEdit ? 'PUT' : 'POST';

    await authFetch(url, {
      method,
      headers: getAuthHeaders(),
      body: JSON.stringify(form),
    });

    setEditing(null);
    setForm(emptyPlan);
    setFeatInput('');
    fetchPlans();
  };

  const handleEdit = (plan) => {
    setEditing(plan.id);
    const feats = typeof plan.features === 'string' ? JSON.parse(plan.features) : (plan.features || []);
    setForm({ ...plan, features: feats, popular: plan.popular ? 1 : 0 });
    setFeatInput(feats.join('\n'));
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer ce tarif ?')) return;
    await authFetch(`/api/admin/pricing.php?id=${id}`, { method: 'DELETE' });
    fetchPlans();
  };

  const handleFeatChange = (value) => {
    setFeatInput(value);
    setForm({ ...form, features: value.split('\n').filter(Boolean) });
  };

  if (loading) return <div className="admin-loading">Chargement...</div>;

  return (
    <div>
      <div className="admin-page-header">
        <h2 className="admin-page-title">Tarifs</h2>
        {editing === null && (
          <button className="btn btn-primary btn-sm" onClick={() => setEditing('new')}>
            <FaPlus /> Ajouter
          </button>
        )}
      </div>

      {editing !== null && (
        <form className="admin-form" onSubmit={handleSubmit}>
          <h3>{editing === 'new' ? 'Nouveau tarif' : 'Modifier le tarif'}</h3>
          <div className="admin-form-grid">
            <div className="admin-field">
              <label>Nom *</label>
              <input type="text" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required />
            </div>
            <div className="admin-field">
              <label>Prix *</label>
              <input type="text" value={form.price} onChange={(e) => setForm({ ...form, price: e.target.value })} required placeholder="990" />
            </div>
            <div className="admin-field full-width">
              <label>Description</label>
              <textarea value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} rows="2" />
            </div>
            <div className="admin-field full-width">
              <label>Fonctionnalités (une par ligne)</label>
              <textarea value={featInput} onChange={(e) => handleFeatChange(e.target.value)} rows="5" placeholder="Design sur mesure&#10;SEO optimisé&#10;Formulaire de contact" />
            </div>
            <div className="admin-field">
              <label>Ordre d'affichage</label>
              <input type="number" value={form.display_order} onChange={(e) => setForm({ ...form, display_order: parseInt(e.target.value) || 0 })} />
            </div>
            <div className="admin-field">
              <label className="admin-checkbox">
                <input type="checkbox" checked={form.popular === 1} onChange={(e) => setForm({ ...form, popular: e.target.checked ? 1 : 0 })} />
                Populaire (mis en avant)
              </label>
            </div>
          </div>
          <div className="admin-form-actions">
            <button type="submit" className="btn btn-primary btn-sm"><FaSave /> Enregistrer</button>
            <button type="button" className="btn btn-secondary btn-sm" onClick={() => { setEditing(null); setForm(emptyPlan); }}>
              <FaTimes /> Annuler
            </button>
          </div>
        </form>
      )}

      <div className="admin-table-wrap">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Nom</th>
              <th>Prix</th>
              <th>Populaire</th>
              <th>Actif</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {plans.length === 0 ? (
              <tr><td colSpan="5" className="admin-empty">Aucun tarif</td></tr>
            ) : (
              plans.map((p) => (
                <tr key={p.id}>
                  <td><strong>{p.name}</strong></td>
                  <td>{p.price} €</td>
                  <td>{p.popular ? 'Oui' : 'Non'}</td>
                  <td>{p.active ? 'Oui' : 'Non'}</td>
                  <td className="admin-actions">
                    <button onClick={() => handleEdit(p)} title="Modifier"><FaEdit /></button>
                    <button onClick={() => handleDelete(p.id)} title="Supprimer" className="danger"><FaTrash /></button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminPricing;
